// extracted by mini-css-extract-plugin
export default {"table":"ShiftsTable_table__kbM8w","header":"ShiftsTable_header__1kRgX","row":"ShiftsTable_row__o00NF","cell":"ShiftsTable_cell__C7Nkc"};